// import { useEffect } from "react";
// import { useNavigate } from "react-router-dom";

// const GoogleCallback = () => {
//   const navigate = useNavigate();

//   useEffect(() => {
//     const urlParams = new URLSearchParams(window.location.search);
//     const accessToken = urlParams.get("accessToken");

//     if (accessToken) {
//       // Sačuvajte accessToken u localStorage
//       localStorage.setItem("accessToken", accessToken);

//       // Očistite URL i redirektujte korisnika
//       navigate("/dash", { replace: true });
//     } else {
//       console.error("Access token nije pronađen!");
//       navigate("/login", { replace: true });
//     }
//   }, [navigate]);

//   return <div>Redirecting...</div>;
// };

// export default GoogleCallback;
import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setCredentials } from "./authSlice";
import useAuth from "../../hooks/useAuth";

const GoogleCallback = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const effectRan = useRef(false);

  useEffect(() => {
    const handleCallback = async () => {
      const params = new URLSearchParams(window.location.search);
      const accessToken = params.get("accessToken");
      console.log("Token", accessToken);

      if (accessToken) {
        dispatch(setCredentials({ accessToken }));
        navigate("/dash");
      } else {
        console.error("Access token nije nadjen");
        navigate("/");
      }
    };

    if (effectRan.current === false) {
      handleCallback();
    }

    return () => {
      effectRan.current = true;
    };
  }, [dispatch, navigate]);

  return <p>Processing login...</p>;
};

export default GoogleCallback;
